import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationPopupComponent } from 'src/app/shared/component/confirmation-popup/confirmation-popup.component';
import { Context } from 'src/app/shared/models/context';
import { Holiday, Message, PrivilegeType, Uploader } from 'src/app/shared/models/domain';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { SettingsService } from 'src/app/shared/services/settings.service';
import { HolidayCrudComponent } from '../holiday-crud/holiday-crud.component';
import { DataService } from 'src/app/shared/services/data.service';

@Component({
  selector: 'app-holiday-list',
  templateUrl: './holiday-list.component.html',
  styleUrls: ['./holiday-list.component.scss'],
})
export class HolidayListComponent implements OnInit {

  public holidays: Holiday[] = [];
  public years: number[] = [];
  public selectedYear: number;
  public isLoading: boolean = true;
  public searchKeyword: string = "";
  public privilege: PrivilegeType;
  private context: Context;
  public uploader!: Uploader;
  public excelFormats: string[];
  constructor(
    private modalService: NgbModal,
    private authService: AuthService,
    private commonService: CommonService,
    private settingsService: SettingsService,
    private dataService: DataService
  ) { }

  ngOnInit(): void {
    this.uploader = {
      apiUrl: '/api/upload/holiday', file: 'file', format: true, template: '/assets/excel/holiday_format.xlsx', headerLabels: ["Name", "Type", "Date"]
    } as Uploader;
    this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges(privilege) });
    this.years = this.commonService.generateYears(5);
    this.selectedYear = new Date().getFullYear();
    this.context = this.authService.getContextData();
    if (this.context && this.context?.companyId) {
      this.getHolidays();
    }
  }

  private getHolidays(clear: boolean = true) {
    if (this.context?.companyId) {
      if (clear) {
        this.isLoading = true;
        this.holidays = [];
      }
      this.settingsService.getHolidays(this.context.companyId, this.selectedYear.toString()).subscribe({
        next: (holidays: Holiday[]) => {
          this.holidays = holidays.sort((a, b) => a.id - b.id);
          this.isLoading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.commonService.setToastr(500, error?.error?.name || error.error);
        }
      });
    } else {
      this.isLoading = false;
    }
  }

  public deleteHoliDay(holiday: Holiday, index: number) {
    if (!this.privilege.canDelete) return;
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.title = "Holiday deletion";
    modalRef.componentInstance.prefixMessage = "Are you sure you want to delete holiday";
    modalRef.componentInstance.message = holiday.name;
    modalRef.componentInstance.label = 'holiday';
    modalRef.result.then((isConfirmed: boolean) => {
      if (isConfirmed) {
        holiday.isDeleteInProgress = true;
        this.settingsService.deleteHoliday(holiday.id).subscribe({
          next: (message: Message) => {
            if (!message.failed) {
              this.commonService.setToastr(200, message.text);
              this.holidays.splice(index, 1);
              this.getHolidays(false);
              holiday.isDeleteInProgress = false;
            } else {
              this.commonService.setToastr(500, message.text);
              holiday.isDeleteInProgress = false;
            }
          },
          error: (error: HttpErrorResponse) => {
            this.commonService.setToastr(500, error?.error?.name || error.error);
            holiday.isDeleteInProgress = false;
          },
        });
      }
    });
  }

  public upsertHoliday(holiday?: Holiday) {
    if (!this.privilege.canEdit) return;
    const modalRef = this.modalService.open(HolidayCrudComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.holiday = holiday;
    modalRef.componentInstance.context = this.context;
    modalRef.result.then((response: Holiday) => {
      if (response.id) {
        this.getHolidays(false);
      }
    })
  }

  public getHolidaysOnYearSelection() {
    this.getHolidays();
  }

  public toggleHolidayStatus(holiday: Holiday) {
    if (!this.privilege.canEdit) {
      setTimeout(() => { holiday.disabled = !holiday.disabled }, 0);
      return;
    }
    this.settingsService.toggleHolidayStatus(holiday).subscribe({
      next: (response: Holiday) => {
        if (response.id) {
          this.commonService.setToastr(200, `Holiday ${holiday.name} is now ${holiday.disabled ? 'disabled' : 'enabled'}!`);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.commonService.setToastr(500, error?.error?.name || error.error);
        holiday.isDeleteInProgress = false;
      },
    });
  }
  public handleUpload(event: Message) {
    if (event.failed == false) this.getHolidays();
  }
}
